import axiosInstance from "../utils/axiosInstance";

export const submitContact = async (data) => {
  const res = await axiosInstance.post("/api/contact", data);
  return res.data;
};
